'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _codevTraverse = require('codev-traverse');

// TODO rename as `mapValuesDeep`, transform as `iteratee`
var middleware = function middleware(iteratee) {
  return function (schema) {
    return function (ctx) {
      return function (next) {
        return function (value) {
          return iteratee(next(value) || value, schema, ctx);
        };
      };
    };
  };
}; /**
    * DFS, 從 leafs 開始 traverse 每個 value
    * 執行 `iteratee(value, schema, ctx)`
    * 回傳值組合成轉換後的值
    */

var mapValuesDeep = function mapValuesDeep(schema) {
  return function (ctx) {
    return function (iteratee) {
      return function (value) {
        return (0, _codevTraverse.traverse)(schema)(middleware(iteratee))(ctx)(value);
      };
    };
  };
};

exports.default = mapValuesDeep;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/transformWithSchema.js
// module id = 1707
// module chunks = 0